import { userService } from '@paragon/data-connections';
import { addSpinnerMessage, removeSpinnerMessage } from '@paragon/task-spinner';

import { User, userLoaded } from '../store/users';
import { AsyncThunkActionVoid, ThunkActionVoid } from './thunkActions';

const userAnnotationColors = ['#996633', '#ffff00', '#cc0000', '#b366ff', '#ff6600'];

function getNextUserAnnotationColor() {
  if (userAnnotationColors.length === 0) {
    return getRandomColor();
  }

  return userAnnotationColors.pop();
}

function getRandomColor() {
  const letters = '0123456789ABCDEF'.split('');

  let color = '#';
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }

  return color;
}

export function loadUser(userEmail: string): AsyncThunkActionVoid {
  return (dispatch, getState) => {
    if (userEmail in getState().users.userData) return Promise.resolve();

    const spinnerId = dispatch(addSpinnerMessage('Loading user...'));

    return userService.users.fetch(userEmail).then((loadedUser) => {
      const user = { ...loadedUser, annotationColor: getNextUserAnnotationColor() };
      dispatch(userLoaded({ loadedUser: user }));
      dispatch(removeSpinnerMessage(spinnerId));
    });
  };
}

export function loadCurrentUser(loadedUser: User): ThunkActionVoid {
  return (dispatch) => {
    dispatch(userLoaded({ loadedUser }));
  };
}
